import FixaTable, {
  FixaTableBody,
  FixaTableHeader,
} from "@coworker/apprestructured/src/shared/wrappers/FixaTable/FixaTable";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import TrashCanIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import { FixaSwitch } from "@coworker/apprestructured/src/shared/wrappers/FixaSwitch/FixaSwitch";
import { CountryPermission } from "../../types/CountryPermission";

type Props = {
  permissions: CountryPermission[];
  isLoading: boolean;
  onToggle: (permissionId: number, currentValue: boolean) => void;
  onDelete: (permissionId: number) => void;
};

const CountryPermissionsPanel = ({
  permissions,
  isLoading,
  onToggle,
  onDelete,
}: Props) => {
  return (
    <FixaTable fullWidth>
      <FixaTableHeader>
        <tr>
          <th>ID</th>
          <th>Country ID</th>
          <th>Permission Code</th>
          <th>Value</th>
          <th>Delete</th>
        </tr>
      </FixaTableHeader>
      <FixaTableBody>
        {isLoading ? (
          <tr>
            <td colSpan={5}>Loading...</td>
          </tr>
        ) : permissions.length === 0 ? (
          <tr>
            <td colSpan={5}>No country permissions found</td>
          </tr>
        ) : (
          [...permissions]
            .sort((a: CountryPermission, b: CountryPermission) => a.id - b.id)
            .map((permission: CountryPermission) => (
              <tr key={permission.id}>
                <td>{permission.id}</td>
                <td>{permission.country_id}</td>
                <td>{permission.permission_id}</td>
                <td>
                  <FixaSwitch
                    checked={permission.value}
                    id={`country-permission-${permission.id}`}
                    value={permission.value.toString()}
                    onChange={() => onToggle(permission.id, permission.value)}
                  />
                </td>
                <td>
                  <FixaButton
                    iconOnly={true}
                    size="small"
                    ssrIcon={TrashCanIconPath}
                    onClick={() => onDelete(permission.id)}
                  />
                </td>
              </tr>
            ))
        )}
      </FixaTableBody>
    </FixaTable>
  );
};

export default CountryPermissionsPanel;
